window.togglePep = function (target, status) {
  var $target = jQuery(target);
  if ($target.length) {
    if ($target.data("plugin_pep") != "undefined") {
      var data = $target.data("plugin_pep");
      data.disableMove = status;
      $target.data("plugin_pep", data);
    }
  }
};
